import axios from 'axios'
import {BaseResponse, Pagination, Response} from '../../models'
import {
  IHakAkses,
  IHakAksesDetail,
  IHakAksesPermission,
  IHakAksesQuery,
  IHakAksesRequest,
} from '../../models/User/HakAkses.model'

export const HAK_AKSES = '/api/v1/admins/division'
export const PERMISSIONS = '/api/v1/admins/permissions'

// react-query key
export const LIST_HAK_AKSES_KEY = 'LIST_HAK_AKSES_KEY'
export const DETAIL_HAK_AKSES_KEY = 'DETAIL_HAK_AKSES_KEY'
export const DETAIL_PERMISSION_KEY = 'DETAIL_PERMISSION_KEY'
export const DETAIL_RECOMMENDATION_KEY = 'DETAIL_RECOMMENDATION_KEY'

export const getListHakAkses = (params?: IHakAksesQuery) => {
  return axios.get<BaseResponse<Pagination<IHakAkses[]>>>(HAK_AKSES, {params})
}

export const getDetailHakAkses = (id?: string) => {
  return axios.get<BaseResponse<Response<IHakAksesDetail>>>(`${HAK_AKSES}/${id}`)
}

export const saveHakAkses = (data?: IHakAksesRequest, id?: string) => {
  if (id) return axios.put(`${HAK_AKSES}/${id}`, data)
  return axios.post(HAK_AKSES, data)
}

export const getTemplatePermission = (level?: 'L1' | 'L2' | 'L3') => {
  return axios.get<BaseResponse<Response<IHakAksesPermission>>>(`${HAK_AKSES}/template/${level}`)
}

export const getRecommendationPermission = (level?: 'L1' | 'L2' | 'L3') => {
  return axios.get<BaseResponse<Response<{active_slug: string[]}>>>(
    `${HAK_AKSES}/recommendation/${level}`
  )
}

export const deleteHakAkses = (id?: string) => {
  return axios.delete(`${HAK_AKSES}/${id}`)
}

export const updateStatusHakAkses = (id?: string, status?: 'ACTIVE' | 'INACTIVE') => {
  return axios.patch(`${HAK_AKSES}/${id}/status/${status}`)
}
